import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router'
import { combineLatest, Observable, of } from 'rxjs'
import { catchError, map, switchMap, take } from 'rxjs/operators'
import { ParseService } from './parse.service'

@Injectable({
    providedIn: 'root',
})
export class OnboardingGuardService implements CanActivate, CanActivateChild {
    private parseService = inject(ParseService)
    private router = inject(Router)

    establishment$ = this.parseService.selectedEstablishment$

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return combineLatest([this.establishment$, this.parseService.roleService.roles$.pipe(map((roles) => !roles.includes('ProFulfillment Payer')))]).pipe(
            switchMap(async ([establishment, isCustomer]) => {
                const onboardingStatus = await this.parseService.getOnboardingStatus(establishment.id)
                return {
                    isCompleted: onboardingStatus?.get('isCompleted') ?? false,
                    isCustomer,
                }
            }),
            take(1),
            map(({ isCompleted, isCustomer }) => {
                if (isCustomer) {
                    return true
                }

                if (state.url === '/signup/thank-you') {
                    if (isCompleted === true) {
                        this.router.navigate(['/products'])
                        return false
                    } else {
                        return true
                    }
                }
                if (state.url !== '/signup/thank-you') {
                    if (isCompleted !== true) {
                        this.router.navigate(['/signup/thank-you'])
                        return false
                    } else {
                        return true
                    }
                }
                return true
            }),
            catchError((err) => {
                this.router.navigate(['/products'])
                return of(false)
            })
        )
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.canActivate(route, state)
    }
}
